module.exports = __webpack_public_path__ + "img/hzico_11.371659ce.jpg";